import React from 'react';
import { motion } from 'framer-motion';

/**
 * Per-mentee daily activity heatmap.
 * Renders a small calendar grid for each mentee showing which days they engaged.
 */
export default function EngagementHeatmap({ data }) {
  if (!data) return null;
  if (data.length === 0) {
    return (
      <div className="codex-card" style={{ padding: 24, textAlign: 'center', opacity: 0.7 }}>
        No mentees to chart yet.
      </div>
    );
  }

  return (
    <div className="codex-card" style={{ padding: 22 }} data-testid="codex-heatmap">
      <div className="codex-eyebrow">ENGAGEMENT — LAST {data[0]?.cells.length || 30} DAYS</div>
      <div style={{ marginTop: 14, display: 'grid', gap: 12 }}>
        {data.map((m, i) => (
          <motion.div
            key={`${m.user_id}-${i}`}
            initial={{ opacity: 0, x: -8 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: Math.min(i * 0.04, 0.4) }}
            style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}
          >
            <div style={{ width: 160, fontSize: 13, color: 'var(--codex-parchment)' }}>
              <div className="codex-display" style={{ fontSize: 14 }}>{m.name}</div>
              <div style={{ fontSize: 11, opacity: 0.7 }}>{m.total_active_days} active days</div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: `repeat(${m.cells.length}, 14px)`, gap: 3 }}>
              {m.cells.map((c) => {
                const intensity = c.completed ? 1 : c.layers / 3;
                const bg = intensity === 0
                  ? 'rgba(255,255,255,0.05)'
                  : `rgba(212, 175, 55, ${0.25 + intensity * 0.65})`;
                return (
                  <div
                    key={c.date}
                    title={`${c.date} · ${c.completed ? 'completed' : `${c.layers}/3 layers`}`}
                    style={{
                      width: 14, height: 14, borderRadius: 3,
                      background: bg,
                      border: c.completed ? '1px solid rgba(212,175,55,0.7)' : '1px solid rgba(255,255,255,0.06)',
                    }}
                  />
                );
              })}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
